import React from "react"
import styled from "styled-components"
import { theme, flex, btnP, btnS } from "@/common/Mixin"
import Link from "next/link"

interface ButtonProps {
  content: string
  type?: string
  onClick?: any
  id?: string
  href?: string
  target?: string
  themeNew?: any
}

export default function Button({
  content,
  type,
  onClick,
  id,
  href,
  target,
  themeNew
}: ButtonProps) {
  const comp = (
    <Wrapper id={id} className={type} themeNew={themeNew} onClick={onClick}>
      {content}
    </Wrapper>
  )
  if (href != null) {
    return (
      <Link href={href ?? ""} target={target}>
        {comp}
      </Link>
    )
  }
  return comp
}

interface WrapperProps {
  themeNew?: any
}

const Wrapper = styled.button<WrapperProps>`
  cursor: pointer;
  ${btnP}
  &.secondary {
    ${btnS}
  }

  border-radius: 100px;
  font-size: 18px;
  font-weight: 900;
  padding: 12px 28px;
  letter-spacing: 0.02em;
  min-width: 160px;
  text-transform: capitalize;
  transition: all 0.3s ease;
  ${flex()}

  &:hover {
    box-shadow:
      0px 16px 40px
        ${({ themeNew }) =>
          themeNew ? themeNew.primary : theme.color.primary}66,
      inset 0px 0px 10px
        ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.white)}66;
    transform: scale(1.05);
    @media (${theme.md}) {
      transform: scale(1);
    }
  }

  @media (${theme.md}) {
    box-shadow: 0px 4px 12px
      ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)}66;
    &:focus,
    &:hover {
      box-shadow:
        0px 4px 16px
          ${({ themeNew }) =>
            themeNew ? themeNew.primary : theme.color.primary}66,
        inset 1px 1px 5px
          ${({ themeNew }) =>
            themeNew ? themeNew.primary : theme.color.primary}44;
    }
  }
  @media (${theme.xl}) {
    margin-left: auto;
    margin-right: auto;
    padding: 12px 20px;
    font-size: 16px;
    &.min {
      height: 32px;
      padding: 4px 24px;
      font-size: 14px;
      min-width: 0px;
    }
  }
`
